<template>
  <div>
    <p class="text-2xl mb-6">Tipo de pago</p>
    <ReporteTipoPagoDetallado :filtrosShow="true" :exportar="['EXCEL']"></ReporteTipoPagoDetallado>
  </div>


</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiLabelVariantOutline, mdiCurrencyUsd, mdiHelpCircleOutline } from '@mdi/js'

// demos
import ReporteTipoPagoDetallado from './componentes/ReporteTipoPagoDetallado.vue';
export default {
  components: {
    ReporteTipoPagoDetallado
  },
  setup() {


    return {}
  },
}
</script>
